import { useMemo } from "react";
import { useAuthContext } from "../../../lib/context/Auth/AuthContext";
import { transport } from "../grpcTransport";
import { PermissionsClient } from "./permissions.client";
import { GetCustomerPermissionsRequest } from "./permissions";

export const useCustomerPermissionsRequests = () => {
  const { tokenInterceptor } = useAuthContext();

  const permissionsClient = useMemo(() => new PermissionsClient(transport), []);

  const getCustomerPermissions = async ({
    customerID,
    accountID,
  }: GetCustomerPermissionsRequest) => {
    if (!customerID || !accountID) {
      throw new Error("User not found!");
    }

    return permissionsClient.getCustomerPermissions(
      {
        customerID: customerID,
        accountID: accountID,
      },
      {
        interceptors: [tokenInterceptor],
      }
    );
  };

  return {
    getCustomerPermissions,
  };
};
